import { render, staticRenderFns } from "./XmEmpty.vue?vue&type=template&id=3babf1c8&scoped=true"
import script from "./XmEmpty.vue?vue&type=script&lang=js"
export * from "./XmEmpty.vue?vue&type=script&lang=js"
import style0 from "./XmEmpty.vue?vue&type=style&index=0&id=3babf1c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3babf1c8",
  null
  
)

export default component.exports